import { actions } from "./action-list";

export function addExportBtnPageName(value) {
  return {
    type: actions.EXPORT_BUTTON_PAGE.ADD_PAGE_NAME,
    value,
  };
}

export function removeExportBtnPageName(value) {
  return {
    type: actions.EXPORT_BUTTON_PAGE.REMOVE_PAGE_NAME,
    value,
  };
}
